(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.directive('syncsettingsRow', ['ItemTableService', 'SynchronisationExtern', 'SynchronisationExternService', 'Alert', SyncSettingsRowDirectiveFn]);

    // row directive for sync settings
    function SyncSettingsRowDirectiveFn(ItemTableService, SynchronisationExtern, SynchronisationExternService, Alert) {
        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/settings/administration/modules/syncsettings/templates/syncsettings-row.template.html'

        };

        return directive;

        function link(scope, element, attrs) {

            // if editing -> this is the original backup
            var original = null;

            // deactivate item (remove from table if it is new)
            scope.deactivate = function () {
                SynchronisationExternService.deactivate(scope.item.id).then(function (result) {
                    Alert.success(result[0]);
                    ItemTableService.deactivate(scope.item, scope.item.vmIndex);
                });
            };

            // edit item
            scope.edit = function () {
                original = ItemTableService.edit(scope.item);
            };

            // cancel editing -> show original
            scope.cancel = function () {
                if (original === null) {
                    ItemTableService.remove(scope.item.vmIndex);
                }
                else {
                    // replace original with current edited item
                    ItemTableService.replace(original, scope.item.vmIndex);
                    // remove backup
                    original = null;
                } // else
            };

            // save editing values
            scope.save = function () {

                // make sure, a user-entity is selected and that user hasn't just typed in a name
                if (typeof scope.item.userDto !== "object" || !scope.item.userDto.id) {
                    Alert.danger("User must be selected from list and not typed-in!");
                    return;
                }

                // save backend
                save();
            };

            // backend save
            function save() {
                // prepare for save
                var item = new SynchronisationExtern();
                item.extend(scope.item);
                item.prepareForSave();

                if (item.thirdParty === null) {
                    Alert.warning("Please select a Third-Party!");
                    return;
                }

                //save or udpate
                if (item.id > 0) {
                    SynchronisationExternService.update(item.id, item).then(function (result) {
                        ItemTableService.save(scope.item);
                        // replace current with edited one
                        scope.item.extend(result);
                        Alert.success('SynchronisationExtern saved successfully');
                    }, function (error) {
                        scope.cancel();
                    });
                }
                else {
                    SynchronisationExternService.save(item).then(function (result) {
                        ItemTableService.save(scope.item);
                        // remove current one to put new one
                        ItemTableService.remove(scope.item.vmIndex);
                        ItemTableService.put(result);

                        Alert.success('SynchronisationExtern saved successfully');
                    });
                }
            }
        }
    }

})();